const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/knowledge.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { useSettingsPanelStore } from "@circle-react/components/Avatars/useSettingsPanelStore";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/ai-agents/edit/$botPublicId/knowledge")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: ({
    preload
  }) => {
    if (!preload) useSettingsPanelStore.getState().open();
  }
});